import { useEffect, useState } from "react";
import api from "@/lib/api";
import { GlassCard, PageLoader } from "@/components/shared";
import { ScrollText } from "lucide-react";

export default function Audit() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/audit").then((r) => setRows(r.data)); }, []);
  if (!rows) return <PageLoader />;
  return (
    <div>
      <div className="mb-6 flex items-center gap-2"><ScrollText className="h-5 w-5 text-cyan-400" /><h1 className="font-display text-2xl font-bold text-slate-50">Audit Log</h1></div>
      <GlassCard className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="border-b border-slate-800 text-left text-xs uppercase text-slate-500">
            <tr><th className="p-3">Date</th><th className="p-3">User</th><th className="p-3">Action</th><th className="p-3">Resource</th><th className="p-3">IP</th><th className="p-3">Result</th></tr>
          </thead>
          <tbody className="divide-y divide-slate-800/60">
            {rows.map((r) => (
              <tr key={r.id} className="hover:bg-slate-900/40">
                <td className="p-3 text-slate-400">{new Date(r.created_at).toLocaleString()}</td>
                <td className="p-3 text-slate-300">{r.user_email}</td>
                <td className="p-3 text-slate-100">{r.action}</td>
                <td className="p-3 font-mono text-xs text-slate-400">{r.resource}</td>
                <td className="p-3 font-mono text-xs text-slate-500">{r.ip || "—"}</td>
                <td className="p-3"><span className={r.result === "success" ? "text-emerald-400" : "text-rose-400"}>{r.result}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </GlassCard>
    </div>
  );
}
